"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var IMAGE_ELEMENT_DEFAULTS = {
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundAttachment: 'initial'
};
var _default = {
  common: {
    customElementGroups: {
      spaceTop: 45,
      spaceBottom: 45,
      _elements: {
        image: IMAGE_ELEMENT_DEFAULTS
      }
    },
    people: {
      spaceTop: 55,
      spaceBottom: 45,
      _elements: {
        header: {
          fontSize: 38
        },
        people: {
          fontSize: 18
        }
      }
    },
    header: {
      spaceTop: 95,
      spaceBottom: 45,
      _elements: {
        image: IMAGE_ELEMENT_DEFAULTS,
        header: {
          fontSize: 52
        }
      }
    }
  },
  trade: {
    header: {
      spaceTop: 95,
      spaceBottom: 45,
      _elements: {
        image: IMAGE_ELEMENT_DEFAULTS
      }
    },
    description: {
      spaceTop: 45,
      spaceBottom: 45
    },
    tickets: {
      spaceTop: 45,
      spaceBottom: 90
    },
    speakers: {
      spaceTop: 45,
      spaceBottom: 45
    },
    attendees: {
      spaceTop: 45,
      spaceBottom: 45
    },
    sponsors: {
      spaceTop: 45,
      spaceBottom: 45
    },
    exhibitors: {
      spaceTop: 45,
      spaceBottom: 45
    },
    multiElement: {
      spaceTop: 45,
      spaceBottom: 45,
      _elements: {
        image: IMAGE_ELEMENT_DEFAULTS
      }
    },
    form: {
      spaceTop: 45,
      spaceBottom: 45,
      _elements: {
        image: IMAGE_ELEMENT_DEFAULTS
      }
    },
    buttons: {
      spaceTop: 45,
      spaceBottom: 45
    },
    downloadApp: {
      spaceTop: 45,
      spaceBottom: 45
    },
    iframe: {
      spaceTop: 50,
      spaceBottom: 0
    },
    // eventVenue: {}
    countdownClock: {
      spaceTop: 45,
      spaceBottom: 45
    },
    people: {
      spaceTop: 45,
      spaceBottom: 45
    }
  },
  urban: {
    header: {
      spaceTop: 170,
      spaceBottom: 30,
      _elements: {
        image: IMAGE_ELEMENT_DEFAULTS
      }
    },
    description: {
      spaceTop: 45,
      spaceBottom: 45
    },
    tickets: {
      spaceTop: 45,
      spaceBottom: 45
    },
    speakers: {
      spaceTop: 45,
      spaceBottom: 45
    },
    attendees: {
      spaceTop: 45,
      spaceBottom: 45
    },
    sponsors: {
      spaceTop: 45,
      spaceBottom: 45
    },
    exhibitors: {
      spaceTop: 45,
      spaceBottom: 45
    },
    multiElement: {
      spaceTop: 45,
      spaceBottom: 45,
      _elements: {
        image: IMAGE_ELEMENT_DEFAULTS
      }
    },
    form: {
      spaceTop: 45,
      spaceBottom: 45,
      _elements: {
        image: IMAGE_ELEMENT_DEFAULTS
      }
    },
    buttons: {
      spaceTop: 45,
      spaceBottom: 45
    },
    downloadApp: {
      spaceTop: 45,
      spaceBottom: 45
    },
    iframe: {
      spaceTop: 50,
      spaceBottom: 0
    },
    countdownClock: {
      spaceTop: 45,
      spaceBottom: 45
    },
    eventVenue: {
      spaceTop: 45,
      spaceBottom: 45
    },
    people: {
      spaceTop: 45,
      spaceBottom: 45
    }
  },
  // AKA "professional"
  business: {
    header: {
      spaceTop: 160,
      spaceBottom: 220,
      _elements: {
        image: IMAGE_ELEMENT_DEFAULTS
      }
    },
    description: {
      spaceTop: 45,
      spaceBottom: 45
    },
    tickets: {
      spaceTop: 50,
      spaceBottom: 220
    },
    speakers: {
      spaceTop: 40,
      spaceBottom: 40
    },
    attendees: {
      spaceTop: 40,
      spaceBottom: 40
    },
    sponsors: {
      spaceTop: 40,
      spaceBottom: 40
    },
    exhibitors: {
      spaceTop: 40,
      spaceBottom: 40
    },
    multiElement: {
      spaceTop: 40,
      spaceBottom: 40,
      _elements: {
        image: IMAGE_ELEMENT_DEFAULTS
      }
    },
    form: {
      spaceTop: 40,
      spaceBottom: 40,
      _elements: {
        image: IMAGE_ELEMENT_DEFAULTS
      }
    },
    buttons: {
      spaceTop: 40,
      spaceBottom: 40
    },
    downloadApp: {
      spaceTop: 40,
      spaceBottom: 40
    },
    iframe: {
      spaceTop: 50,
      spaceBottom: 0
    },
    countdownClock: {
      spaceTop: 40,
      spaceBottom: 40
    },
    eventVenue: {
      spaceTop: 0,
      spaceBottom: 0
    },
    people: {
      spaceTop: 45,
      spaceBottom: 45
    }
  },
  global: {
    header: {
      spaceTop: 0,
      spaceBottom: 0,
      _elements: {
        image: IMAGE_ELEMENT_DEFAULTS
      }
    },
    description: {
      spaceTop: 45,
      spaceBottom: 75
    },
    tickets: {
      spaceTop: 45,
      spaceBottom: 45
    },
    speakers: {
      spaceTop: 45,
      spaceBottom: 45
    },
    attendees: {
      spaceTop: 45,
      spaceBottom: 45
    },
    sponsors: {
      spaceTop: 45,
      spaceBottom: 45
    },
    exhibitors: {
      spaceTop: 45,
      spaceBottom: 45
    },
    multiElement: {
      spaceTop: 45,
      spaceBottom: 45,
      _elements: {
        image: IMAGE_ELEMENT_DEFAULTS
      }
    },
    form: {
      spaceTop: 45,
      spaceBottom: 45,
      _elements: {
        image: IMAGE_ELEMENT_DEFAULTS
      }
    },
    buttons: {
      spaceTop: 45,
      spaceBottom: 45
    },
    downloadApp: {
      spaceTop: 45,
      spaceBottom: 45
    },
    iframe: {
      spaceTop: 50,
      spaceBottom: 0
    },
    // eventVenue: { spaceTop: 0, spaceBottom: 0 }
    countdownClock: {
      spaceTop: 45,
      spaceBottom: 45
    },
    people: {
      spaceTop: 45,
      spaceBottom: 45
    }
  },
  insider: {
    header: {
      spaceTop: 117,
      spaceBottom: 0,
      _elements: {
        image: IMAGE_ELEMENT_DEFAULTS
      }
    },
    description: {
      spaceTop: 145,
      spaceBottom: 50
    },
    tickets: {
      spaceTop: 50,
      spaceBottom: 50
    },
    speakers: {
      spaceTop: 45,
      spaceBottom: 45
    },
    attendees: {
      spaceTop: 45,
      spaceBottom: 45
    },
    sponsors: {
      spaceTop: 45,
      spaceBottom: 45
    },
    exhibitors: {
      spaceTop: 45,
      spaceBottom: 45
    },
    multiElement: {
      spaceTop: 45,
      spaceBottom: 45,
      _elements: {
        image: IMAGE_ELEMENT_DEFAULTS
      }
    },
    form: {
      spaceTop: 45,
      spaceBottom: 45,
      _elements: {
        image: IMAGE_ELEMENT_DEFAULTS
      }
    },
    buttons: {
      spaceTop: 155,
      spaceBottom: 95
    },
    downloadApp: {
      spaceTop: 45,
      spaceBottom: 45
    },
    iframe: {
      spaceTop: 50,
      spaceBottom: 0
    },
    // eventVenue: { spaceTop: 0, spaceBottom: 0 }
    countdownClock: {
      spaceTop: 45,
      spaceBottom: 45
    },
    people: {
      spaceTop: 45,
      spaceBottom: 45
    }
  },
  sleek: {
    header: {
      spaceTop: 110,
      spaceBottom: 65,
      _elements: {
        image: IMAGE_ELEMENT_DEFAULTS
      }
    },
    description: {
      spaceTop: 30,
      spaceBottom: 30
    },
    tickets: {
      spaceTop: 30,
      spaceBottom: 30
    },
    speakers: {
      spaceTop: 0,
      spaceBottom: 0
    },
    attendees: {
      spaceTop: 0,
      spaceBottom: 0
    },
    sponsors: {
      spaceTop: 30,
      spaceBottom: 30
    },
    exhibitors: {
      spaceTop: 30,
      spaceBottom: 30
    },
    multiElement: {
      spaceTop: 45,
      spaceBottom: 45,
      _elements: {
        image: IMAGE_ELEMENT_DEFAULTS
      }
    },
    form: {
      spaceTop: 45,
      spaceBottom: 45,
      _elements: {
        image: IMAGE_ELEMENT_DEFAULTS
      }
    },
    buttons: {
      spaceTop: 30,
      spaceBottom: 30
    },
    downloadApp: {
      spaceTop: 30,
      spaceBottom: 30
    },
    iframe: {
      spaceTop: 50,
      spaceBottom: 0
    },
    // eventVenue: { spaceTop: 0, spaceBottom: 0 }
    countdownClock: {
      spaceTop: 0,
      spaceBottom: 60
    },
    people: {
      spaceTop: 45,
      spaceBottom: 45
    }
  },
  classic: {
    header: {
      spaceTop: 110,
      spaceBottom: 15,
      _elements: {
        image: IMAGE_ELEMENT_DEFAULTS
      }
    },
    description: {
      spaceTop: 40,
      spaceBottom: 40
    },
    tickets: {
      spaceTop: 30,
      spaceBottom: 40
    },
    speakers: {
      spaceTop: 55,
      spaceBottom: 55
    },
    attendees: {
      spaceTop: 55,
      spaceBottom: 55
    },
    sponsors: {
      spaceTop: 15,
      spaceBottom: 15
    },
    exhibitors: {
      spaceTop: 40,
      spaceBottom: 40
    },
    multiElement: {
      spaceTop: 40,
      spaceBottom: 40,
      _elements: {
        image: IMAGE_ELEMENT_DEFAULTS
      }
    },
    form: {
      spaceTop: 0,
      spaceBottom: 0,
      _elements: {
        image: IMAGE_ELEMENT_DEFAULTS
      }
    },
    buttons: {
      spaceTop: 40,
      spaceBottom: 40
    },
    downloadApp: {
      spaceTop: 40,
      spaceBottom: 40
    },
    iframe: {
      spaceTop: 50,
      spaceBottom: 0
    },
    // eventVenue: { spaceTop: 0, spaceBottom: 0 }
    countdownClock: {
      spaceTop: 40,
      spaceBottom: 40
    },
    people: {
      spaceTop: 45,
      spaceBottom: 45
    }
  }
};
exports.default = _default;